export default "__VITE_ASSET__B21BB8fw__"